"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _Helpers = require("../Helpers");
var _ykbUtils = require("ykb-utils");
var seperateValue = function seperateValue(value) {
  if ((0, _ykbUtils.isNullOrUndefined)(value)) return null;
  var splittedValue = parseFloat(value).toFixed(2).split('.').join('');
  return parseInt(splittedValue);
};
var isCheckFilteredValue = function isCheckFilteredValue(original, columnId, filterValues) {
  if ((0, _ykbUtils.isNullOrUndefined)(original[columnId])) return false;
  var _filterValues = (0, _slicedToArray2.default)(filterValues, 5),
    type = _filterValues[0],
    props = _filterValues[1],
    columnDef = _filterValues[2],
    min = _filterValues[3],
    max = _filterValues[4];
  var value = String(original[columnId]) || '0';
  var preparedValue = typeof value === 'string' ? seperateValue(value) : value * 100;
  return seperateValue(min) >= preparedValue || seperateValue(max) <= preparedValue;
};
var NumberFilter = function NumberFilter(row, filterValues) {
  var _filterValues2 = (0, _slicedToArray2.default)(filterValues, 3),
    _ = _filterValues2[0],
    props = _filterValues2[1],
    column = _filterValues2[2];
  var filteredValue = column.filteredValue || column.dataIndex;
  var exist = isCheckFilteredValue(row, filteredValue, filterValues);
  // let nestedExist = false;
  // if (!exist && Array.isArray(row.original.children)) {
  //   const list = Utils.flatten(row.original.children);
  //   nestedExist = list.some(item =>
  //     isCheckFilteredValue(item, filteredValue, filterValues)
  //   );
  // }
  // const isExpanded = row.getIsExpanded();
  // const returnVal = exist || nestedExist;
  // if (returnVal && !isExpanded) {
  //   const handleExpand = row.getToggleExpandedHandler();
  //   handleExpand();

  //   const filterData = Object.assign(row.original, { rowId: row.id });
  //   props?.onExpandByFilter(filterData);
  // }
  return exist;
};
var _default = exports.default = NumberFilter;